// tab-panel — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
    --_padding: var(--run-tab-panel-padding, var(--run-space-semantic-md));
    --_background: var(--run-tab-panel-background, transparent);
    --_color: var(--run-tab-panel-color, var(--run-color-text-primary));
  }

  :host([hidden]) {
    display: none;
  }

  :host(:focus-visible) {
    outline: 2px solid var(--run-color-focus-ring);
    outline-offset: 2px;
    transition: outline-color var(--run-motion-semantic-micro-duration, 0.1s) ease;
  }

  [part="base"] {
    padding-block: var(--_padding);
    padding-inline: var(--_padding);
    background: var(--_background);
    color: var(--_color);
  }
`;

export function render(host) {
  const { active } = host;
  host.shadowRoot.innerHTML = `
    <div part="base"${active ? ' data-active' : ''}>
      <slot></slot>
    </div>
  `;
}
